import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  startIconClassName?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      hasError,
      startIcon,
      endIcon,
      containerClassName,
      startIconClassName,
      type,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          [
            'transition-colors',
            'bg-white flex items-center gap-2 h-11 px-3.5 py-3',
            'border border-input rounded-lg',
            'shadow-[0px_1px_2px_0px_hsla(218,28%,17%,0.05)]',
            'focus-within:ring-4 focus-within:ring-[hsla(var(--primary),0.1)] focus-within:border-primary-400',
            'hover:border-primary-300',
          ],
          {
            'cursor-not-allowed bg-grayscale-50': disabled,
            'border-error-200 focus-within:border-error-200 focus-within:ring-[hsla(var(--error-400),0.1)]': hasError,
          },
          containerClassName
        )}
      >
        {startIcon && (
          <span className={cn('inline-flex', startIconClassName)}>
            {startIcon}
          </span>
        )}

        <input
          type={type}
          disabled={disabled}
          className={cn(
            [
              'flex-grow py-1 border-none font-sans text-sm text-grayscale-800 rounded-none',
              'placeholder:text-sm placeholder:text-grayscale-400',
              'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
              'focus-visible:outline-none',
              'disabled:cursor-not-allowed disabled:bg-grayscale-50 disabled:placeholder:text-grayscale-600',
              'autofill:bg-inherit',
            ],
            {
              'cursor-not-allowed bg-inherit': disabled,
            },
            className
          )}
          ref={ref}
          {...props}
        />

        {endIcon && <span className="inline-flex">{endIcon}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
